import { Component, OnInit } from '@angular/core';
import { HttpRequestService } from './../../_services/http-request.service';
import { CommonService } from './../../_services/common.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  searchType: Array<any> = [];
  searchCount: number = 0;
  searchKeyword: any = '';
  constructor(private httpServices: HttpRequestService, private toastr: ToastrService,
    private commonService: CommonService, private modalService: NgbModal,
    public translate: TranslateService, private activatedRoute: ActivatedRoute) {
    this.commonService.activelang.subscribe((lang) => {
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(lang);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(lang);
    });
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((param) => {
      this.searchKeyword = param.key;
      if (param.type) {
        this.activeSearchType = param.type;
      }
    });
    this.translate.get([
      'BOOKS',
      'TOPIC',
      'ARTICLES',
      'WEBINARS',
      'EVENTS',
      'AUTHOR',
      'VIDEOS'
    ]).subscribe((tData) => {
      let tDataValue = Object.values(tData);
      let tdataKey = Object.keys(tData);
      tDataValue.forEach((item, index) => {
        this.searchType.push({
          value: item,
          key: tdataKey[index],
          page: -1
        });
      });
      if (!this.activeSearchType) {
        this.activeSearchType = tdataKey[0];
      }
      this.searchByType(this.activeSearchType);
    });
  }

  activeSearchType: any = null;
  searchData: Array<any> = [];
  searchByType(type) {
    this.activeSearchType = type;
    let activeIndex = this.searchType.findIndex((i) => i.key == this.activeSearchType);
    this.searchType[activeIndex].page = -1;
    this.search();
    let url = new URL(window.location.href);
    url.searchParams.set('type', type);
    window.history.pushState({ path: url.href }, '', url.href);
  }
  search() {
    let activeIndex = this.searchType.findIndex((i) => i.key == this.activeSearchType);
    let page = this.searchType[activeIndex].page;
    page += 1;
    if (page == 0) {
      this.searchData = [];
    }
    this.httpServices.setModule('action').post('search_list', {
      "browse_char": this.searchKeyword,
      "filter_type": this.activeSearchType,
      "page": page,
      "page_size": 1
    }).subscribe((response) => {

      if (response.status == 'success') {
        this.searchType[activeIndex].page = page;
        this.searchData = this.searchData.concat(response.data.list.rows);
        this.searchCount = response.data.list.count;
      }
      if (response.status == 'error') {
        this.toastr.error(response.data, 'Error');
      }
    }, (error) => {
      console.log(error);
    });
  }
  searchByenteredKey(event) {
    if (event.which == 13) {
      let url = new URL(window.location.href);
      url.searchParams.set('key', this.searchKeyword);
      window.history.pushState({ path: url.href }, '', url.href);
      this.searchByType(this.activeSearchType);
    }
  }
  openVideoModal(content, video) {
    // console.log(video);
    this.modalService.open(content, { size:'xl',  centered: true });
    document.getElementById('videoTitle').innerText = video.local[0].title;
    document.getElementById('videoDescription').innerText = video.local[0].description; 
    document.getElementById('videoIfream').setAttribute('src', 'https://www.youtube.com/embed/'+video.video_code); 
  }
}
